/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import {
  actionToSplash,
  actionToSplashHome,
  actionToSplashLower,
  actionToSplashInterview
} from "./scrollTrigger/scrollTrigger-splash";

/**
 * hintBrowser
 * will-changeを外す
 */
var willChangeItem = document.querySelectorAll(".hintBrowser");

function hintBrowser() {
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("hintBrowser");
  }
}

/**
 * スプラッシュ
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      if (window.document.body.classList.contains("home")) {
        actionToSplashHome()
      } else if (window.document.body.classList.contains("interview")) {
        actionToSplashInterview()
      } else {
        actionToSplashLower()
      }
      actionToSplash()
      hintBrowser()
    }, 1000);
  });
};

/**
 * ページ遷移アニメーション
 */
// const anchorLinks = document.querySelectorAll('a:not([href^="#"]):not([href^="javascript:void(0);"]):not([target]):not(.toggle__area)');
// const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

// anchorLinksArr.forEach((link) => {
//   link.addEventListener("click", (e) => {
//     e.preventDefault();
//     let url = e.currentTarget.href;

//     if (url !== '') {
//       actionToPageMove();

//       setTimeout(() => {
//         window.location = url;
//       }, 500);
//     }

//     return false;
//   })
// });

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};